import React from "react";
import { AiOutlineExclamationCircle } from "react-icons/ai";

export default function ErrorPopup({ show, message, onClose, Erro }) {
  if (!show) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
      <div className="bg-white rounded-2xl shadow-2xl w-11/12 max-w-lg p-8 relative animate-fade-in">
        <button
          className="absolute top-4 right-4 text-gray-400 hover:text-gray-700 text-3xl font-bold"
          onClick={onClose}
        >
          ×
        </button>

        <div className="flex flex-col items-center mb-6">
          <div className="w-24 h-24 rounded-full bg-red-100 flex items-center justify-center mb-4">
            <AiOutlineExclamationCircle className="text-red-600 text-6xl" />
          </div>
          <h2 className="text-2xl font-bold text-red-600">{Erro}</h2>
        </div>

        <p className="text-center text-gray-700 text-lg">{message}</p>

        <div className="mt-8 flex justify-center">
          <button
            onClick={onClose}
            className="bg-red-600 hover:bg-red-700 text-white px-10 py-3 rounded-xl text-xl font-semibold transition-colors"
          >
            OK
          </button>
        </div>
      </div>
    </div>
  );
}
